import React from "react";

export default function Footer() {
  return (
    <div>
      {/*                footer slider image                  */}
      <div>
        <h1 className="text-center font-semibold">f o o t e r</h1>
      </div>
      {/*                footer slider image                  */}
    </div>
  );
}
